/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationScope,
  Credentials,
  KeycloakToken,
  Token,
} from '../models';
import {
    ApplicationScopeFromJSON,
    ApplicationScopeToJSON,
    CredentialsFromJSON,
    CredentialsToJSON,
    KeycloakTokenFromJSON,
    KeycloakTokenToJSON,
    TokenFromJSON,
    TokenToJSON,
} from '../models';

export interface GetTokenRequest {
    xApplicationScope: ApplicationScope;
    credentials: Credentials;
}

export interface PerformKeycloakLoginForAnonymousUserRequest {
    xApplicationScope: ApplicationScope;
    credentials: Credentials;
}

export interface PerformKeycloakLogoutRequest {
    xApplicationScope: ApplicationScope;
}

/**
 * 
 */
export class AuthControllerApi extends runtime.BaseAPI {

    /**
     * create an access token
     * create an access token
     */
    async getTokenRaw(requestParameters: GetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling getToken.');
        }

        if (requestParameters.credentials === null || requestParameters.credentials === undefined) {
            throw new runtime.RequiredError('credentials','Required parameter requestParameters.credentials was null or undefined when calling getToken.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CredentialsToJSON(requestParameters.credentials),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenFromJSON(jsonValue));
    }

    /**
     * create an access token
     * create an access token
     */
    async getToken(requestParameters: GetTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token> {
        const response = await this.getTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * perform keycloak login for anonymous user
     * perform keycloak login for anonymous user
     */
    async performKeycloakLoginForAnonymousUserRaw(requestParameters: PerformKeycloakLoginForAnonymousUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<KeycloakToken>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling performKeycloakLoginForAnonymousUser.');
        }

        if (requestParameters.credentials === null || requestParameters.credentials === undefined) {
            throw new runtime.RequiredError('credentials','Required parameter requestParameters.credentials was null or undefined when calling performKeycloakLoginForAnonymousUser.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        const response = await this.request({
            path: `/token/keycloak`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CredentialsToJSON(requestParameters.credentials),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => KeycloakTokenFromJSON(jsonValue));
    }

    /**
     * perform keycloak login for anonymous user
     * perform keycloak login for anonymous user
     */
    async performKeycloakLoginForAnonymousUser(requestParameters: PerformKeycloakLoginForAnonymousUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<KeycloakToken> {
        const response = await this.performKeycloakLoginForAnonymousUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * perform keycloak logout
     * perform keycloak logout
     */
    async performKeycloakLogoutRaw(requestParameters: PerformKeycloakLogoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.xApplicationScope === null || requestParameters.xApplicationScope === undefined) {
            throw new runtime.RequiredError('xApplicationScope','Required parameter requestParameters.xApplicationScope was null or undefined when calling performKeycloakLogout.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.xApplicationScope !== undefined && requestParameters.xApplicationScope !== null) {
            headerParameters['X-Application-Scope'] = String(requestParameters.xApplicationScope);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/token/keycloak`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * perform keycloak logout
     * perform keycloak logout
     */
    async performKeycloakLogout(requestParameters: PerformKeycloakLogoutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.performKeycloakLogoutRaw(requestParameters, initOverrides);
    }

}
